import React, { useEffect, useState } from "react";

const SectionTitle = ({
    title
}) => {
    return (
        <div className="tw:!font-hanken-grotesk tw:!mb-4 tw:!text-[15px] tw:!font-[600] tw:!text-[#282828]">
            <span className="tw:relative tw:inline-block">
                <span className="tw:absolute tw:bottom-0 tw:left-0 tw:right-0 tw:h-[40%] tw:rounded-full tw:bg-[#F9EDD3]" />
                <span className="tw:relative">{title}</span>
            </span>
        </div>
    );
};

export default SectionTitle;
